import React from "react";
import DatePickerComponent from "../DatePickerComponent";
import DropDownComponentSorted from "../DropDownComponentSorted";
import DropDownComponent from "../DropDownComponent";
import InputComponent from "../InputComponent";
import DropDownClientIdentifier from "../Dropdowns/DropDownClientIdentifier";
import "../PreAdmission.css";

function AdmissionInformation({
  eta,
  handlEtaChange,
  durationOfStay,
  handleDurationOfStayChange,
  needsNonSmokingRoom,
  handleNeedsNonSmokingRoomChange,
  passportStatus,
  handlePassportStatusChange,
  passportCopy,
  handlePassportCopy,
  previousClientIdentifier,
  handlePreviousClientIdentifier,
  flightDetails,
  handleFlightDetailsChange,
  flightDetailsContent,
  handleFlightDetailsContent,
  vipTransfer,
  handleVipTransferChange,
  paymentDetails,
  handlePaymentDetailsChange,
  nationality,
  handleNationalityChange,
  maritalStatus,
  handleMaritalStatusChange,
  currentPartner,
  handleCurrentPartnerChange,
  requiresDurationOfStay = true,
}) {
  return (
    <div className="admission-information-column">
      <section className="admission-information-card">
        <div className="admission-information-heading">
          <span className="pre-admission-section-kicker">Admission details</span>
          <h2>Admission Information</h2>
          <p>Arrival, stay and travel information</p>
        </div>
        <div className="admission-information-section-title">Arrival & stay</div>
        <div className="tab-form-container-v2 admission-information-grid admission-information-grid-arrival">
          <DatePickerComponent
            title="Estimate Date of Arrival"
            width="150px"
            value={eta}
            onChange={handlEtaChange}
          />

          {requiresDurationOfStay && (
            <DropDownComponentSorted
              api="durationOfStay"
              title="Intended duration of stay"
              width="250px"
              value={durationOfStay}
              onChange={handleDurationOfStayChange}
              showValidation={true}
            />
          )}
        </div>
        <div className="admission-information-section-title">Documents & client details</div>
        <div className="tab-form-container-v2 admission-information-grid">
          <DropDownComponent
            api="yesno"
            title="Needs non-smoking room?"
            value={needsNonSmokingRoom}
            onChange={handleNeedsNonSmokingRoomChange}
            showValidation={false}
          />

          <InputComponent
            title="Passport status"
            width="300"
            value={passportStatus}
            onChange={handlePassportStatusChange}
            showValidation={true}
          />

          <DropDownComponent
            api="pendingReceived"
            title="Passport copy"
            value={passportCopy}
            onChange={handlePassportCopy}
            showValidation={true}
          />
          <DropDownClientIdentifier
            title="Previous client identifier (if returning client)"
            value={previousClientIdentifier}
            onChange={handlePreviousClientIdentifier}
            showValidation={false}
          />
        </div>
        <div className="admission-information-section-title">Flight information</div>
        <div className="tab-form-container-v2 admission-information-grid">
          <DropDownComponent
            api="pendingReceived"
            title="Flight details"
            value={flightDetails}
            onChange={handleFlightDetailsChange}
            showValidation={true}
          />

          <InputComponent
            title="Itinerary"
            width="150"
            value={flightDetailsContent}
            onChange={handleFlightDetailsContent}
            showValidation={true}
          />
        </div>

        <div className="admission-information-section-title">Transfer & payment</div>
        <div className="tab-form-container-v2 admission-information-grid">
          <DropDownComponent
            api="pendingBooked"
            title="VIP transfer"
            value={vipTransfer}
            onChange={handleVipTransferChange}
            showValidation={true}
          />
          <DropDownComponent
            api="paymentDetail"
            title="Payment details"
            value={paymentDetails}
            onChange={handlePaymentDetailsChange}
            showValidation={true}
          />
        </div>

        <div className="admission-information-section-title">Personal details</div>
        <div className="tab-form-container-v2 admission-information-grid">
          <DropDownComponent
            api="nationalities"
            title="Nationality"
            value={nationality}
            onChange={handleNationalityChange}
            showValidation={true}
          />

          <DropDownComponent
            api="maritalStatus"
            title="Marital status"
            value={maritalStatus}
            onChange={handleMaritalStatusChange}
            showValidation={true}
          />
        </div>
        <div className="tab-form-container-v2 admission-information-grid admission-information-grid-partner">
          <InputComponent
            title="If married not checked, do you have a current partner?"
            width="300"
            value={currentPartner}
            onChange={handleCurrentPartnerChange}
          />
        </div>
      </section>
    </div>
  );
}

export default AdmissionInformation;

